import { Injectable } from '@angular/core';

import { WidgetsService } from '@main/widgets/shared/services/widgets.service';

@Injectable()
export class CategoriesWidgetsService extends WidgetsService {}
